import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "item", "empty"]

  filter() {
    const query = this.queryTarget.value.trim().toLocaleLowerCase()
    let visible = 0

    this.itemTargets.forEach((item) => {
      const matches = item.dataset.searchText.toLocaleLowerCase().includes(query)
      item.classList.toggle("hidden", !matches)
      if (matches) visible += 1
    })

    this.emptyTarget.classList.toggle("hidden", visible > 0)
  }
}
